module.exports = __webpack_public_path__ + "static/media/link.fd0d5546.png";